export default "__VITE_ASSET__CBAf_kpE__"